import { motion } from 'framer-motion';

/**
 * Loading Skeleton Component
 * Shimmer effect placeholder for content that's loading
 * Used for 3D previews, images, and other async content
 */

export const LoadingSkeleton = ({
  width = '100%',
  height = '200px',
  borderRadius = '12px',
  className = '',
}) => (
  <motion.div
    animate={{
      background: [
        'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%)',
        'linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 50%, #e2e8f0 100%)',
      ],
    }}
    transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'linear',
    }}
    style={{
      width,
      height,
      borderRadius,
      position: 'relative',
      overflow: 'hidden',
    }}
    className={className}
  >
    {/* Optional shimmer overlay */}
    <motion.div
      animate={{
        x: ['-100%', '100%'],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
      }}
    />
  </motion.div>
);

/**
 * Card Skeleton - Pre-configured for NFC card preview
 */
export const CardSkeleton = () => (
  <LoadingSkeleton
    width="100%"
    height="300px"
    borderRadius="12px"
  />
);

/**
 * Text Skeleton - For loading text placeholders
 */
export const TextSkeleton = ({ lines = 3, width = '100%' }) => (
  <div style={{ width }}>
    {Array.from({ length: lines }).map((_, index) => (
      <LoadingSkeleton
        key={index}
        width={index === lines - 1 ? '70%' : '100%'}
        height="16px"
        borderRadius="4px"
        style={{ marginBottom: '8px' }}
      />
    ))}
  </div>
);

export default LoadingSkeleton;
